import React from "react";

import CustomTermPoints from "../termsAndConditions/customTermPoints";
import { useTranslation } from "react-i18next";

const ConsentDataTransferContainer = () => {
  const { t, i18n } = useTranslation();

  const isRTL = i18n.language === "ar";

  return (
    <div
      className={`  max-container ${isRTL ? "rtl" : "ltr"}`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div
        className={` ${
          isRTL ? "text-right" : "text-left"
        } px-5  shadow-lg py-5 lg:py-10 space-y-2 flex flex-col gap-y-5`}
      >
        <CustomTermPoints title={t("consentDataTransferPoint1")} />
        <CustomTermPoints title={t("consentDataTransferPoint2")} />
        <CustomTermPoints title={t("consentDataTransferPoint3")} />
        <CustomTermPoints title={t("consentDataTransferPoint4")} />
      </div>
    </div>
  );
};

export default ConsentDataTransferContainer;
